import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getConfControladorGrupoList } from './selectdbAtions';

class SelectControladorParaTicket extends Component {
  componentDidMount() {
    // Busca a lista de controladores sempre que o componente é montado
    // ou quando o grupo físico mudar (ver chamada no componente pai)
    if (this.props.grupoFisicoId) {
      this.props.getConfControladorGrupoList(this.props.grupoFisicoId);
    }
  }

  componentDidUpdate(prevProps) {
    // Se o grupo físico selecionado no formulário mudou, busca a nova lista de controladores
    if (prevProps.grupoFisicoId !== this.props.grupoFisicoId) {
      if (this.props.grupoFisicoId) {
        this.props.getConfControladorGrupoList(this.props.grupoFisicoId);
      }
    }
  }

  renderOptions() {
    const list = this.props.list || [];
    const anel = this.props.anel !== false;

    if (!this.props.grupoFisicoId) {
      return <option value="">Selecione um Grupo Físico primeiro</option>;
    }
    if (list.length === 0) {
      return <option value="">Carregando ou nenhum controlador no grupo...</option>;
    }

    return list.map(contro => (
      <option
        key={contro.id}
        value={contro.id}
        data-numero={contro.numero_controlador}
        data-anel={contro.anel}
        style={{ display: anel || contro.anel === 1 ? '' : 'none' }}
      >
        {`${contro.numero_controlador} - ${contro.endereco}`}
      </option>
    ));
  }

  handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    return (
      <div style={{ marginTop: '5px' }}>
        <select
          id={'selectControladorTicket'}
          name={'selectControladorTicket'}
          style={{ width: '240px', display: 'inline' }}
          className={'form-control'}
          onChange={event => this.handleChange(event)}
          value={this.props.value || '0'}
          disabled={!this.props.grupoFisicoId} // Desabilita se nenhum grupo for selecionado
        >
          <option value="0">Selecione...</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.controladorCad.listConf });
const mapDispatchToProps = dispatch => bindActionCreators({ getConfControladorGrupoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectControladorParaTicket);
